import { put, call, select, all } from "redux-saga/effects";
import { saveBandInfoAPI } from "../api/SaveBandInfo";
import { saveBandSuccess, saveBandFailed } from "../actions/editbandactions";
import { reportError, reportSuccess } from "../actions/erroractions";

const getBandInfo = (state) => ({
  name: state.editband.name,
  desc: state.editband.desc,
  location: state.editband.location,
  genre1: state.editband.genre1,
  is_second_genre: state.editband.is_second_genre,
  genre2: state.editband.genre2,
  bandPicture: state.editband.pictureToUpload ? state.editband.bandPicture : null,
  pictureCrop: state.editband.pictureCrop,
  pictureToUpload: state.editband.pictureToUpload
});

export function* saveBandSaga() {
  try {

    const bandInfo = yield select(getBandInfo);

    const result = yield call(saveBandInfoAPI, bandInfo);

    if (result.exists) {
      yield all([
        put(saveBandSuccess(result.url)),
        put(reportSuccess("Successfully saved band")),
      ]);
    } else {
      yield all([put(saveBandFailed()), put(reportError(result.message))]);
    }
  } catch (e) {
    yield all([
      put(saveBandFailed()),
      put(reportError("Unable to reach server")),
    ]);
  }
}
